import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/core/services/message.service';
import { BehaviorSubject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-cargo-closure',
    templateUrl: './cargo-closure.component.html',
    styleUrls: ['./cargo-closure.component.scss']
})

export class CargoClosureComponent implements OnInit {

    options = {
        columnTitles: ['Id', 'Bulto' , 'Rack'],
        columnReferences: ['id', 'bult', 'rack'],
        actionButtons: { edit: true, delete: true }
    };

    form: FormGroup;
    submitted: boolean;

    dataSource = new BehaviorSubject([]);

    data: any[] = [];
    captured: any[] = [];

    os: string;
    vehicle: string;
    bult: string;
    total = 0;

    constructor(private messageService: MessageService, private formBuilder: FormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            os: ['', Validators.required],
            vehicle: ['', Validators.required],
        });
    }

    get controls() { return this.form.controls; }

    onLoadBults() {
        if (!this.os) {
            return;
        }

        this.clean();

        if (this.os === 'OPS358562') {
            this.data = [
                { id: 1, bult: '000200OPS22454', rack: true },
                { id: 2, bult: '000200OPS22455', rack: false },
                { id: 3, bult: '000200OPS22456', rack: true },
                { id: 4, bult: '000200OPS22457', rack: true }
            ];
            this.dataSource.next(this.data);

            this.total = this.data.length;
        } else if (this.os === 'OPS358563') {
            this.messageService.warning('Validación de negocio', 'La orden de salida se encuentra en proceso de Carga');
        } else {
            this.messageService.error('Error', 'El OS buscado no existe');
        }
    }

    onEnterBult() {
        if (!this.bult) {
            return;
        }

        const bult = this.data.find(x => x.bult === this.bult);
        if (bult) {
            this.captured.push(bult);
            const index = this.data.indexOf(bult);
            if (index !== -1) {
                this.data.splice(index, 1);
            }
            this.dataSource.next(this.data);
        } else {
            const captured = this.captured.find(x => x.bult === this.bult);
            if (captured) {
                this.messageService.warning('Validación de negocio', 'El bulto ya ha sido capturado');
            } else {
                this.messageService.error('Error', 'El número de bulto no corresponde al conjunto de bultos de la orden de salida');
            }
        }

        this.bult = '';
    }

    onCargoClosure() {
        this.submitted = true;
        this.controls.vehicle.markAsTouched();
        this.controls.os.markAsTouched();

        if (this.total !== this.captured.length) {
            this.messageService.error('Error', 'Hay bultos pendientes de carga');
        } else if (!this.form.invalid) {
            this.messageService.success('Éxito', 'Carga cerrada correctamente');
            this.cleanAll();
        }
    }

    private clean() {
        this.captured = [];
        this.data = [];
        this.dataSource.next(this.data);
    }

    private cleanAll() {
        this.clean();
        this.total = 0;
        this.os = '';
        this.vehicle = '';
        this.form.reset({});
    }

}
